import { AppointmentById_appointment_data_notes } from 'gql/appointments/__generated__/AppointmentById';

export const replaceNotesWithArrayValues = (
  notes: AppointmentById_appointment_data_notes[],
  sentences: string[]
) => {
  let noteIndex = 0;

  for (let i = 0; i < notes.length; i++) {
    if (notes[i].sender === 2) {
      notes[i] = { ...notes[i], note: sentences[noteIndex] };
      noteIndex++;
    }
  }

  return notes;
};
